var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerApp"},[_c('Header'),_c('Horas',{staticClass:"bodyApp"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }